export default __webpack_public_path__ + "static/media/fireFN35.e4c6a22a.svg";